import React from 'react';

const TestError: React.FC = () => {
  throw new Error('Simulate Error');
};

export default TestError;
